<template>
    <ies-form-field :field="field">
        <input :name="this.field.fieldName" type="text" v-model="input" v-on:keyup="updateField()" :required="this.field.required" :disabled="this.field.disabled">
    </ies-form-field>
</template>

<script>
    export default {
        name: 'ies-htmlinput',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data () {
            return {
                input: this.field.value || this.field.oldValue
            }
        },
        methods: {
            updateField: function() {
                this.field.value = this.input
            }
        },
        watch: {
            input: function(val) {
                this.field.value = this.input;
            }
        }
    }
</script>
